export default {
  process() {
    return {};
  },

  getEmpty() {
    return [];
  },
};
